// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import QuestionBox from "./QuestionBox-APP_CLIENT.styled";

export interface QuestionBoxProps {
  // number of options the page offers; absent for boxes that are not a category
  $optionsCount?: number;
}

export default QuestionBox;
